class PasswordResetSentUsersController {
  static controller($scope, $state) {
    'ngInject';

    $scope.login = $state.params.login;
  };
}

export default PasswordResetSentUsersController.controller;



// WEBPACK FOOTER //
// ./src/users/forgot-password/password-reset-sent.users.controller.js